// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Dashboard from "../Dashboard/Dashboard";
// import Home from "../pages/Home";

// import Signin from "../Dashboard/signin";
// import ManageUser from "../pages/ManageUser";
// import Department from "../pages/Department";
// import Services from "../pages/Services/Services";
// import OfflineServices from "../pages/OfflineServices";
// import LoginPage1 from "../pages/LoginPage1";
// import LoginPage2 from "../pages/LoginPage2";
// import LoginPage3 from "../pages/LoginPage3";
// import LoginPage4 from "../pages/LoginPage4";
// import LoginPage5 from "../pages/LoginPage5";
// import LoginPage6 from "../pages/LoginPage6";
// import LoginPage7 from "../pages/LoginPage7";
// import ForgotPassword from "../Dashboard/ForgotPassword";
// import DocumentMaster from "../pages/DocumentMaster";
// import EmailSetup from "../pages/EmailSetup";
// import UploadDocument from "../pages/Upload-Document";
// import GazettedMaster from "../pages/Gazetted-Master";
// import ManageDocumentsPage from "../pages/ManageDocPage";
//  import RoleCreation from "../pages/RoleCreation";
// import SanjayGandhi from "../pages/SanjavGandhi/SanjayGandhi";
// import Rehabilitation from "../pages/Rehabilitation/Rehabilitation";
// import SendNotification from "../pages/SendNotificaion";
// import { useThemeMode } from "../Dashboard/Theme";
// import ProtectedRoute from "./ProtectedRoute";
// import SJYGandhiDashboard from "../Dashboard/SJYGandhi-Dashboard";
// import LandAcquistionReport from "../pages/Reports/LandAcquistion-Report";
// import SJYGandhiReport from "../pages/Reports/SJYGandhi-Report";
// import LandAcquisition from "../Dashboard/LandAcquisition-Dashboard";
// import ManageDocPage from "../pages/ManageDocPage";
// import SendMessageReport from "../pages/Reports/SendMessage-Report";
// import SendNotificationDashboard from "../Dashboard/SendNotification-Dashboard";
// import EmailConfiguration from "../pages/EmailConfiguration";
// import SendEmailDashboard from "../Dashboard/SendEmail-Dashboard";
// import EMailSendReport from "../pages/Reports/EMailSend-Report";

// export default function Routing() {
//   const { roleAccess } = useThemeMode();

//   return (
//     <>
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<Signin />} />
//           <Route path="forgot-password" element={<ForgotPassword />} />
//           <Route path="dashboard" element={<Dashboard />}>
//             {/* <Route path="home" element={<Home />} /> */}
//             <Route
//               path="home"
//               element={
//                 <ProtectedRoute menuId={1} roleAccess={roleAccess}>
//                   <Home />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="LandAcquisition"
//               element={
//                 <ProtectedRoute menuId={13} roleAccess={roleAccess}>
//                   <LandAcquisition />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="SJYGandhiDashboard"
//               element={
//                 <ProtectedRoute menuId={14} roleAccess={roleAccess}>
//                   <SJYGandhiDashboard />
//                 </ProtectedRoute>
//               }
//             />
//              <Route
//               path="SendNotificationDashboard"
//               element={
//                 <ProtectedRoute menuId={2} roleAccess={roleAccess}>
//                   <SendNotificationDashboard />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="SendEmailDashboard"
//               element={
//                 <ProtectedRoute menuId={3} roleAccess={roleAccess}>
//                   <SendEmailDashboard />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="manage-user"
//               element={
//                 <ProtectedRoute menuId={3} roleAccess={roleAccess}>
//                   <ManageUser />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="RoleCreation"
//               element={
//                 <ProtectedRoute menuId={12} roleAccess={roleAccess}>
//                   <RoleCreation />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="department"
//               element={
//                 <ProtectedRoute menuId={6} roleAccess={roleAccess}>
//                   <Department />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="Services"
//               element={
//                 <ProtectedRoute menuId={7} roleAccess={roleAccess}>
//                   <Services />
//                 </ProtectedRoute>
//               }
//             />
//             {/* <Route path="OfflineServices" element={<OfflineServices />} /> */}
//             <Route
//               path="OfflineServices"
//               element={
//                 <ProtectedRoute menuId={8} roleAccess={roleAccess}>
//                   <OfflineServices />
//                 </ProtectedRoute>
//               }
//             />
//             {/* <Route
//               path="DocumentMaster"
//               element={
//                 <ProtectedRoute menuId={5} roleAccess={roleAccess}>
//                   <DocumentMaster />
//                 </ProtectedRoute>
//               }
//             /> */}
//             <Route
//               path="ManageDocPage"
//               element={
//                 <ProtectedRoute menuId={5} roleAccess={roleAccess}>
//                   <ManageDocPage />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="EmailSetup"
//               element={
//                 <ProtectedRoute menuId={13} roleAccess={roleAccess}>
//                   <EmailSetup />
//                 </ProtectedRoute>
//               }
//             />
//              <Route
//               path="EmailConfiguration"
//               element={
//                 <ProtectedRoute menuId={2} roleAccess={roleAccess}>
//                   <EmailConfiguration />
//                 </ProtectedRoute>
//               }
//             />
//             {/* <Route path="Gazetted-Master" element={<GazettedMaster />} /> */}
//             <Route
//               path="Gazetted-Master"
//               element={
//                 <ProtectedRoute menuId={4} roleAccess={roleAccess}>
//                   <GazettedMaster />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="Upload-Document"
//               element={
//                 <ProtectedRoute menuId={9} roleAccess={roleAccess}>
//                   <UploadDocument />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="SanjayGandhi"
//               element={
//                 <ProtectedRoute menuId={10} roleAccess={roleAccess}>
//                   <SanjayGandhi />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="Rehabilitation"
//               element={
//                 <ProtectedRoute menuId={11} roleAccess={roleAccess}>
//                   <Rehabilitation />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="SendNotification"
//               element={
//                 <ProtectedRoute menuId={2} roleAccess={roleAccess}>
//                   <SendNotification />
//                 </ProtectedRoute>
//               }
//             />
//             {/* ==============REPORT========== */}
//             <Route
//               path="LandAcquistionReport"
//               element={
//                 <ProtectedRoute menuId={15} roleAccess={roleAccess}>
//                   <LandAcquistionReport />
//                 </ProtectedRoute>
//               }
//             />{" "}
//             <Route
//               path="SJYGandhiReport"
//               element={
//                 <ProtectedRoute menuId={16} roleAccess={roleAccess} >
//                   <SJYGandhiReport />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="SendMessageReport"
//               element={
//                 <ProtectedRoute menuId={20-4} roleAccess={roleAccess}>
//                   <SendMessageReport />
//                 </ProtectedRoute>
//               }
//             />
//              <Route
//               path="EMailSendReport"
//               element={
//                 <ProtectedRoute menuId={20-5} roleAccess={roleAccess}>
//                   <EMailSendReport />
//                 </ProtectedRoute>
//               }
//             />
//            </Route>
//           {/* <Route path="/dashboard/special" element={<SpecialLayout />}> */}
//           <Route path="LoginPage1" element={<LoginPage1 />} />
//           <Route path="LoginPage2" element={<LoginPage2 />} />
//           <Route path="LoginPage3" element={<LoginPage3 />} />
//           <Route path="LoginPage4" element={<LoginPage4 />} />
//           <Route path="LoginPage5" element={<LoginPage5 />} />
//           <Route path="LoginPage6" element={<LoginPage6 />} />
//           <Route path="LoginPage7" element={<LoginPage7 />} />
//           {/* </Route> */}
//         </Routes>
//       </BrowserRouter>
//     </>
//   );
// }

import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";
import ForgotPassword from "../Dashboard/ForgotPassword";
import LandAcquisition from "../Dashboard/LandAcquisition-Dashboard";
import SendEmailDashboard from "../Dashboard/SendEmail-Dashboard";
import SendNotificationDashboard from "../Dashboard/SendNotification-Dashboard";
import Signin from "../Dashboard/signin";
import SJYGandhiDashboard from "../Dashboard/SJYGandhi-Dashboard";
import { useThemeMode } from "../Dashboard/Theme";
import EmailConfiguration from "../pages/EmailConfiguration";
import EmailSetup from "../pages/EmailSetup";
import GazettedMaster from "../pages/Gazetted-Master";
import Home from "../pages/Home";
import ManageDocPage from "../pages/ManageDocPage";
import ManageUser from "../pages/ManageUser";
import Rehabilitation from "../pages/Rehabilitation/Rehabilitation";
import EMailSendReport from "../pages/Reports/EMailSend-Report";
import LandAcquistionReport from "../pages/Reports/LandAcquistion-Report";
import SendMessageReport from "../pages/Reports/SendMessage-Report";
import SJYGandhiReport from "../pages/Reports/SJYGandhi-Report";
import RoleCreation from "../pages/RoleCreation";
import SanjayGandhi from "../pages/SanjavGandhi/SanjayGandhi";
import SendNotification from "../pages/SendNotificaion";
import UploadDocument from "../pages/Upload-Document";
import ProtectedRoute from "./ProtectedRoute";

export default function Routing() {
  const { roleAccess } = useThemeMode();
  console.log("roleAccess", roleAccess);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Signin />} />
          <Route path="forgot-password" element={<ForgotPassword />} />

          <Route path="dashboard" element={<Dashboard />}>
            {/* ── Dashboards ─────────────────────────────────── */}

            {/* MenuId: 1 */}
            <Route
              path="home"
              element={
                <ProtectedRoute menuId="1" roleAccess={roleAccess}>
                  <Home />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 13 */}
            <Route
              path="LandAcquisition"
              element={
                <ProtectedRoute menuId="13" roleAccess={roleAccess}>
                  <LandAcquisition />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 14 */}
            <Route
              path="SJYGandhiDashboard"
              element={
                <ProtectedRoute menuId="14" roleAccess={roleAccess}>
                  <SJYGandhiDashboard />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 19 → oSpecialAccess MenuId: 2 (WhatsApp Camp Dash) */}
            <Route
              path="SendNotificationDashboard"
              element={
                <ProtectedRoute menuId="19-2" roleAccess={roleAccess}>
                  <SendNotificationDashboard />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 19 → oSpecialAccess MenuId: 3 (Email Camp Dash) */}
            <Route
              path="SendEmailDashboard"
              element={
                <ProtectedRoute menuId="19-3" roleAccess={roleAccess}>
                  <SendEmailDashboard />
                </ProtectedRoute>
              }
            />

            {/* ── Setup ──────────────────────────────────────── */}

            {/* MenuId: 2 (update when backend confirms) */}
            <Route
              path="EmailConfiguration"
              element={
                <ProtectedRoute menuId="2" roleAccess={roleAccess}>
                  <EmailConfiguration />
                </ProtectedRoute>
              }
            />

            {/* ── Users & Roles ──────────────────────────────── */}

            {/* MenuId: 3 */}
            <Route
              path="manage-user"
              element={
                <ProtectedRoute menuId="3" roleAccess={roleAccess}>
                  <ManageUser />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 12 */}
            <Route
              path="RoleCreation"
              element={
                <ProtectedRoute menuId="12" roleAccess={roleAccess}>
                  <RoleCreation />
                </ProtectedRoute>
              }
            />

            {/* ── Masters ────────────────────────────────────── */}

            {/* MenuId: 4 */}
            <Route
              path="Gazetted-Master"
              element={
                <ProtectedRoute menuId="4" roleAccess={roleAccess}>
                  <GazettedMaster />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 5 (Documents Master — add if in backend) */}
            <Route
              path="ManageDocPage"
              element={
                <ProtectedRoute menuId="5" roleAccess={roleAccess}>
                  <ManageDocPage />
                </ProtectedRoute>
              }
            />

            {/* ── Upload Documents ───────────────────────────── */}

            {/* MenuId: 9 — has oSpecialAccess but route itself just needs MenuId:9 */}
            <Route
              path="Upload-Document"
              element={
                <ProtectedRoute menuId="9" roleAccess={roleAccess}>
                  <UploadDocument />
                </ProtectedRoute>
              }
            />

            {/* ── Sanjay Gandhi & Rehabilitation ─────────────── */}

            {/* MenuId: 10 */}
            <Route
              path="SanjayGandhi"
              element={
                <ProtectedRoute menuId="10" roleAccess={roleAccess}>
                  <SanjayGandhi />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 11 */}
            <Route
              path="Rehabilitation"
              element={
                <ProtectedRoute menuId="11" roleAccess={roleAccess}>
                  <Rehabilitation />
                </ProtectedRoute>
              }
            />

            {/* ── Campaign ───────────────────────────────────── */}

            {/* MenuId: 17 (WhatsApp Campaign) */}
            <Route
              path="SendNotification"
              element={
                <ProtectedRoute menuId="17" roleAccess={roleAccess}>
                  <SendNotification />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 18 (Email Campaign) */}
            <Route
              path="EmailSetup"
              element={
                <ProtectedRoute menuId="18" roleAccess={roleAccess}>
                  <EmailSetup />
                </ProtectedRoute>
              }
            />

            {/* ── Reports ────────────────────────────────────── */}

            {/* MenuId: 15 */}
            <Route
              path="LandAcquistionReport"
              element={
                <ProtectedRoute menuId="15" roleAccess={roleAccess}>
                  <LandAcquistionReport />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 16 */}
            <Route
              path="SJYGandhiReport"
              element={
                <ProtectedRoute menuId="16" roleAccess={roleAccess}>
                  <SJYGandhiReport />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 20 → oSpecialAccess MenuId: 4 */}
            <Route
              path="SendMessageReport"
              element={
                <ProtectedRoute menuId="20-4" roleAccess={roleAccess}>
                  <SendMessageReport />
                </ProtectedRoute>
              }
            />

            {/* MenuId: 20 → oSpecialAccess MenuId: 5 */}
            <Route
              path="EMailSendReport"
              element={
                <ProtectedRoute menuId="20-5" roleAccess={roleAccess}>
                  <EMailSendReport />
                </ProtectedRoute>
              }
            />
          </Route>
          {/* end /dashboard */}
        </Routes>
      </BrowserRouter>
    </>
  );
}
